
import { Col, Row } from "react-bootstrap";

export const Newsletter = () => {
  

 
  


  return (
      <Col lg={12}>
        <div className="newsletter-bx wow slideInUp">
          <Row className="justify-content-center">
            <Col lg={12}>

              <h3>Programming is an art where logic meets creativity. Every line of code solves problems, builds innovations,
          and shapes the future. Challenges push boundaries, and failures teach resilience. Inspired by technology
          pioneers, coders transform ideas into reality. Stay curious, keep learning, and embrace coding’s endless
          possibilities. The journey is worth it!</h3>
             
            </Col>
          </Row>
        </div>
      </Col>
  )
}
